<template>
  <div id="popup-container">
    <v-container ref="container" class="iframe-container">
      <!-- <embed style="width: 100%; height: 100vh" :src="this.url" /> -->
      <iframe :src="this.url"/>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn color="grey300" class="mr-4 cancel-button" @click="closePanel">Close</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>

export default {
  name: "ResourceDetail",
  props: {
    url: {
      type: String
    }
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    }
  }
};
</script>

<style scoped>
.slideout-panel .slideout-wrapper .slideout{
  overflow-y: hidden;
}
.slideout .container{
  padding: 0 !important;
}
.iframe-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 91%;
  border: none;
}
</style>